import '_config/common/index'

//Module in multiple chunks
require.include('common/helpers/renderHelper');

// force run global (fix ie11 bug)
const prototypeInit = require('@lnw/base/global').prototypeInit;
prototypeInit()

